import React from 'react'

const TableSkeleton = ({
    speed = 2, width = "100%", height = 400, viewBox = "0 0 100% 400",
    backgroundColor = "#f3f3f3", foregroundColor = "#e1e1e1",noOfRows=8,
    rowWidth="100%",rowHeight="28",xValue="0",yValue="10"
}) => {
    const containerStyle = {
        width,
        height,
        paddingTop: Number(yValue),
        paddingLeft: Number(xValue),
        paddingRight: 0,
        overflow: 'hidden'
    };

    const shimmerStyle = {
        background: `linear-gradient(90deg, ${backgroundColor} 25%, ${foregroundColor} 50%, ${backgroundColor} 75%)`,
        backgroundSize: '200% 100%',
        animation: `table-skeleton-loading ${speed}s ease-in-out infinite`
    };

    return (
        <>
            <style>
                {`
                    @keyframes table-skeleton-loading {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}
            </style>
            <div style={containerStyle} aria-label="Loading" role="status">
                {
                    new Array(noOfRows).fill("skell").map((el, i) => {
                        return (
                            <div
                                key={`${el}-${i}`}
                                style={{
                                    ...shimmerStyle,
                                    width: rowWidth,
                                    height: Number(rowHeight),
                                    marginBottom: 10
                                }}
                            />
                        )
                    })
                }
            </div>
        </>
    )
}

export default TableSkeleton
